import { render, staticRenderFns } from "./TabBeneficiaryHistoryPPP3.vue?vue&type=template&id=1da7efe6&"
import script from "./TabBeneficiaryHistoryPPP3.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiaryHistoryPPP3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports